import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';

@inject(AuthService, Router)
export class MenuShort {
    constructor(authService, router) {

        this.authService = authService;
        
        var items = JSON.parse(sessionStorage.getItem("magnfi_account"));
        this.captureKey = items.link_id;

        this.route = "";
        this.route =(localStorage.getItem('rout'))? localStorage.getItem('rout') : ""; 
        console.log("Short Menu Route:",this.route);
        if(this.route.includes("#/user/video/request"))
        {
            this.selected = 1;
        }
        else if(this.route.includes("#/user/video/brand"))
        {
            this.selected = 2;
        }
        else if(this.route.includes("#/user/video/email"))
        {
            this.selected = 3;
        }
        else if(this.route.includes("#/user/video/message"))
        {
            this.selected = 4;
        }
        else if(this.route.includes("#/user/video/caseStudy"))
        {
            this.selected = 5;
        }
        else if(this.route.includes("#/user/contacts"))
        {
            this.selected = 6;
        }
    }
    activate() { }
    detached() { }
    load() { }
}
